angular.module('mtic.components.dashboards.student_general')
.directive('studentLeaderboard', function (
  $log,
  EventManager,
  language,
  StudentDataService,
  userAccount,
  $sce,
  DEV_VARIABLES,
  PlatformService,
  cordovaMessenger
  )
{
  return {
    templateUrl: 'template.html',
    scope: {
        classType: '='
    },
    link: function (scope, element) {

      var eventManager = new EventManager('studentLeaderboard', scope);
    

      var init = function (){
        var lang = language.getCurrentSelectedLanguage();
        const country = getCountryLeaderboard(StudentDataService.leaderboardConfig ? StudentDataService.leaderboardConfig.classCountry || '' : '');
        let url = `https://demo.mathematic.org/student/leaderboards/district/${country}`;
        url += `/foreignClassType/${getForeignClassType()}`;
        url += `/foreignClassId/${getForeignClassId()}`;
        url += `/foreignId/${getForeignUid()}`;
        url += `/displayName/${encodeURIComponent(getDisplayName())}`;
        url += `/${lang}`;
        scope.iframeUrl = $sce.trustAsResourceUrl(url);
      }

      /**
       * Please refer to groups.groupType == 'country' in the db for what country names its expecting
       * If updating this, please update the one in mtic2\src\components\dashboards\teacher\teacher-students-class-leaderboard\index.js as well :/
       * @param {string} country
       * @returns {string}
       */
      var getCountryLeaderboard = (country) => {
        const countryLowerCase = (country || '').toLowerCase();
        switch (countryLowerCase) {
          case 'testing': return 'testing';
          case 'israel': return 'baqa';
          default: return 'luxembourg';
        }
      }

      var getForeignClassId = function(){
        if (StudentDataService.leaderboardConfig){
          
          var isNoClass = false;
          _.each(DEV_VARIABLES.GROUPS.LUXEMBOURG.TEACHERLESS_MODULES, function(classModule){
            if (classModule.group_id === StudentDataService.leaderboardConfig.classId){
              isNoClass = true;
            }
          })

          if(isNoClass){
            return 'individualMode_' + getForeignUid();
          }

          return StudentDataService.leaderboardConfig.classId;
        }
        return 0;
      }
      var getForeignClassType = function(){
          if (StudentDataService.leaderboardConfig){
            return StudentDataService.leaderboardConfig.classType;
          }
          return 'cx';
      }

      var getForeignUid = function(){
          $log.log('user ids', userAccount.getData().uuid, userAccount.getData().user_id)
        return userAccount.getData().user_id;
      }
      var getDisplayName = function(){
        return userAccount.getData().fullName;
      }
      
      var optionIdToTransId = {
        'modules': 14569,
        'dashboard': 27651
      }
      scope.getTranslation = function(option_id){
        var translationId = optionIdToTransId[option_id];
        if (translationId){
          return language.get(translationId);
        }
        else{
          return '';
        }
      }
      scope.getProperTranslation = function(id) {
        return language.get(id);
      }

      init();

    }
  }
});
